import React from "react";
import classNames from "classnames";
import "./ColorBlock.scss";

import { Text } from "..";

export interface InterfaceColorBlock {
  title: string;
  hexCode: string;
  variable: string;
  mode: "light" | "dark";
  description?: string;
}

function ColorBlock({
  title,
  hexCode,
  variable,
  mode,
  description,
}: InterfaceColorBlock): JSX.Element {
  const blockClassName = classNames("nimbus-web--color-block", `nimbus-web--color-block--${mode}`);
  
  const blockStyle = {backgroundColor: hexCode};

  return (
    <div className={blockClassName} style={blockStyle}>
      <div className="nimbus-web--color-block__title">
        <Text bold>{title}</Text>
      </div>
      <div className="nimbus-web--color-block__info">
        <Text size="small">{hexCode}</Text>
        <Text size="small">{variable}</Text>
      </div>
      {description && (
        <div className="nimbus-web--color-block__description">
          <Text size="small">{description}</Text>
        </div>
      )}
    </div>
  );
}

export default ColorBlock;